// ============================================
// 上岸小搭子 - 主布局组件
// ============================================

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TabBar from '../TabBar';
import './MainLayout.scss';

const MainLayout: React.FC = () => {
  const location = useLocation();
  
  // 判断是否在登录页
  const isLoginPage = location.pathname === '/login';
  
  // 判断是否在二级页面（需要隐藏tabbar）
  const isSubPage = location.pathname.startsWith('/practice/') || 
                    location.pathname.includes('/course/live/') ||
                    location.pathname.includes('/course/video/') ||
                    location.pathname.includes('/course/teacher/');

  if (isLoginPage) {
    return <Outlet />;
  }

  return (
    <div className="main-layout">
      <div className="main-content">
        <Outlet />
      </div>
      {!isSubPage && <TabBar />}
    </div>
  );
};

export default MainLayout;
